import { mapToCanActivate, Routes } from '@angular/router';

import { AuthGuard } from '@next/core-lib/authorization';

import { OverviewComponent } from './soil-analysis/components/overview/overview.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: OverviewComponent,
    canActivate: mapToCanActivate([AuthGuard]),
    data: {
      pageTitle: 'title',
    },
  },
];
